import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Compose class names with clsx conditional logic and dedupe
// conflicting Tailwind utilities via tailwind-merge.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
